import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getMaterialPullAdvertisers(data) {
    return request.get(`/${platform}/material_pull/advertisers`, data)
}

export function addMaterialPullAdvertiser(data) {
    return request.post(`/${platform}/material_pull/advertisers`, data)
}

export function deleteMaterialPullAdvertiser(data) {
    return request.delete(`/${platform}/material_pull/advertisers/${data.ids}`, data)
}

export function getMaterialPullRecords(data) {
    return request.get(`/${platform}/material_pull/records`, data)
}

export function createMaterialPullTask(data) {
    return request.post(`/${platform}/material_pull/tasks`, data)
}

export function getMaterialPullProgress(data) {
    return request.get(`/${platform}/material_pull/tasks/progress`, data)
}
